import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './ContactDetailsCard.styles';
const ContactDetailsCard = ({ address, content, cta, email, phone, officePhone, mobilePhone, title, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } })),
            React.createElement(S.InfoGrid, null,
                address && (React.createElement(S.InfoCol, null,
                    React.createElement(S.IconHolder, null,
                        React.createElement(S.Pin, null)),
                    React.createElement(S.InfoColInner, null,
                        React.createElement(S.InfoColContent, { dangerouslySetInnerHTML: { __html: address } }),
                        cta && React.createElement(LinkButton, { title: cta.text, href: cta.url, target: cta.target })))),
                (phone || officePhone || mobilePhone) && (React.createElement(S.InfoCol, null,
                    React.createElement(S.IconHolder, null,
                        React.createElement(S.Phone, null)),
                    React.createElement(S.InfoColInner, null,
                        phone && (React.createElement(S.Link, { href: `tel:${phone}` }, phone)),
                        officePhone && (React.createElement(S.Link, { href: `tel:${officePhone}` },
                            "Office: ",
                            officePhone)),
                        mobilePhone && (React.createElement(S.Link, { href: `tel:${mobilePhone}` },
                            "Mobile: ",
                            mobilePhone))))),
                email && (React.createElement(S.InfoCol, null,
                    React.createElement(S.IconHolder, null,
                        React.createElement(S.Envelope, null)),
                    React.createElement(S.InfoColInner, null,
                        React.createElement(S.Link, { href: `mailTo:${email}` }, email))))))));
};
export default ContactDetailsCard;
